module.exports = __webpack_public_path__ + "static/media/exit.ffe225d0.svg";